import {connect} from '@gisatcz/ptr-state';

import Action from "../../state/Action";
import Select from "../../state/Select";

import presentation from './presentation';

const mapStateToProps = (state, ownProps) => {
    return {
        activeVisualizationSection: Select.components.get(state, 'visualizations', 'activeSection'),
        selections: Select.selections.getAllAsObject(state)
    };
};

const mapDispatchToProps = (dispatch, ownProps) => {
    return {
        onSectionChange: (key) => {
            dispatch(Action.components.set('visualizations', 'activeSection', key));
            dispatch(Action.specific.eo4sdDrrInsarMyanmar20.setActiveSelection(key));
        }
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(presentation);
